/* eslint-disable handle-callback-err */
/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
export default class Policies extends Component {
  constructor (props) {
    super(props)
    this.state = {
      acceptedPolicies:this.props.acceptedPolicies || false,
      policyLink: '',
      preferredCampus:''
    }
  }
  static getDerivedStateFromProps(props,state) {
    if(props.preferredCampus!==state.preferredCampus)
    {
      return {preferredCampus:props.preferredCampus}
    }else{
      return null
    }
  }

  componentDidMount () {
    
    this.setState({preferredCampus:this.props.preferredCampus})
    fetch(`${process.env.REACT_APP_API_URL}/api/login/getPolicyLink`)
      .then(res => res.json())
      .then(res => {
        this.setState({ policyLink: res })
      })
      .catch(err => this.setState({ policyLink: '#' }))
  }


    

  render () {
    const preferredCampus=this.state.preferredCampus
    return (
      <div>
    
     <p>   o	Meeting the minimum requirements does not guarantee admission to the university but rather ensures entry to the selection and assessment process.</p>
<p>o	Admission to the university is based on your academic records and achievements, with no regards to age, gender, race, color or disability of any kind.</p>
<p>o	Any health-related issues will only be regarded as health-based information and will not affect your acceptance to the university.</p>
<p>o	Refunding the full Down payment is according to the following conditions:</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;o	Within fourteen (14) days from the date of payment (presenting the proof of payment is a must).</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;o	If the application is not eligible to receive the final acceptance letter.</p>
<p>o	Application fees (1,200 EGP) are not refundable.</p>
<p>o	The Tuition Fees are set in the respective currency of the parent university, and for Egyptian Students Only these fees will be paid in equivalent in EGP based on the announced exchange rates of the Central Bank of Egypt on the date of payment.</p>
{preferredCampus=='West'? <p>o	Please note that TKH New Zayed Campus <b>is due to</b> operate starting the second semester of 23/24 Academic Year.<br/>o	Students joining the New Zayed Campus will attend the first semester of the 23/24 Academic Year in The New Administrative Capital’s Campus and the second semester at The New Zayed Campus.</p>:null}
<p style={{fontStyle:'italic'}} >Privacy rules prevent us from disclosing information to anyone but you about your application unless you authorize a specific person on your behalf in this section. Once you are admitted, this person will no longer have access to your file.</p>
  <p style={{fontStyle:'italic'}} ><b>If there are any omission of key information or any documents submitted in support of your application are found to be fraudulent, the university reserves the right to reject or withdraw the application and the offer made.</b></p>
  
        <p><input type='checkbox' value={this.state.acceptedPolicies} onChange={() => {
          this.props.collectState('Policies', !this.state.acceptedPolicies)
          this.setState(prevState => ({
            acceptedPolicies: !prevState.acceptedPolicies
          }))
        }
        } checked={this.state.acceptedPolicies}/> Accept Policies</p>
      </div>
    )
  }
}
Policies.propTypes = {
  collectState: PropTypes.func.isRequired,
  acceptedPolicies: PropTypes.bool,
  preferredCampus:PropTypes.string
}
